import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import LogoImage from '../../assets/images/cw-logo.jpg';

const LogoMain = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" gap={1} py={2}>
      <Box
        component="img"
        src={LogoImage}
        alt="Calderwood Logo"
        sx={{
          height: 'auto',
          width: '225px'
        }}
      />
    </Box>
  );
};

LogoMain.propTypes = {
  reverse: PropTypes.bool
};

export default LogoMain;
